import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-[#2C3E5F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="bg-white rounded-lg p-3 inline-block mb-4 shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/mwmdalj9_Dharani%20Pipe%20Logo.png" 
                alt="Dharani Pipes" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('footer.aboutText')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-200">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white transition-colors duration-200">
                  {t('nav.products')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-200">
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <Link to="/enquiry" className="text-gray-300 hover:text-white transition-colors duration-200">
                  {t('nav.enquiry')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  {t('contact.info.addressValue')}
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0" />
                <div className="text-gray-300 text-sm">
                  <div>
                    <a href="tel:+919036493100" className="hover:text-white hover:underline transition-colors">
                      +91 9036493100
                    </a>
                  </div>
                  <div>
                    <a href="tel:+918539466804" className="hover:text-white hover:underline transition-colors">
                      +91 8539466804
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-3 flex-shrink-0" />
                <div className="text-gray-300 text-sm">
                  <a href="mailto:sales@dharanipipes.com" className="hover:text-white hover:underline transition-colors break-all">
                    sales@dharanipipes.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Dharani Pipes Private Limited. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
